// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"Checkbox_checkboxLabel__fS39V","checkboxInput":"Checkbox_checkboxInput__bJifA"};